import axios from 'axios'

const Axios = axios.create({
  baseURL: 'https://caspian-contacts.lemueltech.com/contacts'
  // baseURL: 'http://localhost:4600/contacts'
  // baseURL: 'http://192.168.43.42:4600/contacts',
})

export default Axios;
